import React from 'react'
import { LayoutSubmenuCP } from 'submodules/nerit-framework-ui/common/components/screen/layout-with-submenu/layout/LayoutSubmenuCP'
import { TitleBrowserCP } from 'submodules/nerit-framework-ui/common/components/title-browser/TitleBrowserCP'
import { QAQCScreenUtils, QAQC_GENERAL, ScreenQAQCViewTP } from 'modules/reports/screens/screen-qaqc/inner/QAQCScreenUtils'
import { AppStateUtils } from 'app/redux/AppStateUtils'

/**
 */
export function ScreenQAQC(): JSX.Element {

    return (
        <>
            <TitleBrowserCP pageName={'QAQC'} />
            <LayoutSubmenuCP<ScreenQAQCViewTP>
                menuTitle={'QAQC'}
                loggedDomain={AppStateUtils.getDomainData()?.slug}
                defaultSubmenu={'ionicBalanceHistory'}
                defaultOpenKeys={[QAQC_GENERAL]}
                submenuConfigs={QAQCScreenUtils.getSubMenuConfigs()}
            />
        </>
    )
}
